import React from "react";
import {CASES_DATE_RANGE_MAP} from "src/components/StryfeAPI/Constants";

const UnderProcessingCaseWidget = (props) => {

    function setInvoicesVisible() {
        props.data.onClick(true);
    }

    function updateStartDate(date: string) {
        props.data.updateStartDate(date);
    }

    function updateEndDate(date: string) {
        props.data.updateEndDate(date);
    }

    function updateCaseStatus(caseStatus: string) {
        props.data.updateCaseStatus(caseStatus);
    }

    return (
        <div onClick={setInvoicesVisible}>
            <div onClick={() => {
                updateStartDate(CASES_DATE_RANGE_MAP.completedCasesDateRange.startDate),
                    updateEndDate(CASES_DATE_RANGE_MAP.completedCasesDateRange.endDate),
                    updateCaseStatus(props.data.caseStatus)
            }}>
                <h4 className="blue-600">Processing : {props.data.underProcessingWidgetData.count}</h4>
            </div>
            <br/>
        </div>
    )
}
export default UnderProcessingCaseWidget;